module.exports = __webpack_public_path__ + "img/MOE-S.8b62fce6.png";